import axios from "../utils/AxiosInstance";
import { ResponseMessage } from "../models/ResponseMessage";
import { LoginResponse } from "../models/LoginResponse";
import { MfaSetupReponse } from "../models/MfaSetupResponse";
import { ChangePasswordRequest } from "../models/AccountModels";
import { Constants } from "../constants/constants";
const API_BASE_URL = Constants.API_BASE_URL;

// ✅ Verify Email (works fine)
export async function verifyEmail(
  token: string
): Promise<ResponseMessage<any>> {
  const response = await axios.get(`${API_BASE_URL}/accounts/verify-email`, {
    params: { token }, // Axios automatically converts to ?token=value
  });

  // If your backend returns the same ResponseMessage<T> shape
  return ResponseMessage.fromJson(response.data);
}

// ✅ Register function using axios (recommended)
export async function registerAsync(
  email: string,
  password: string,
  name: string,
  contact: string
): Promise<ResponseMessage<string>> {
  const response = await axios.post(`${API_BASE_URL}/accounts/register`, {
    email,
    password,
    name,
    contact,
  });

  // Convert backend JSON into a typed ResponseMessage<string> object
  return ResponseMessage.fromJson<string>(response.data);
}

// ✅ Register function using axios (recommended)
export async function loginAsync(
  email: string,
  password: string
): Promise<ResponseMessage<LoginResponse>> {
  const response = await axios.post(`${API_BASE_URL}/accounts/login`, {
    email,
    password,
  });

  // Convert backend JSON into a typed ResponseMessage<string> object
  return ResponseMessage.fromJson<LoginResponse>(response.data);
}

export async function resetPasswordRequestAsync(
  email: string
): Promise<ResponseMessage<boolean>> {
  const response = await axios.post(
    `${API_BASE_URL}/accounts/request-password-reset`,
    {
      email,
    }
  );

  // Convert backend JSON into a typed ResponseMessage<string> object
  return ResponseMessage.fromJson<boolean>(response.data);
}

export async function resetPasswordAsync(
  refreshToken: string,
  newPassword: string
): Promise<ResponseMessage<boolean>> {
  const response = await axios.post(`${API_BASE_URL}/accounts/reset-password`, {
    refreshToken,
    newPassword,
  });

  // Convert backend JSON into a typed ResponseMessage<string> object
  return ResponseMessage.fromJson<boolean>(response.data);
}

export async function postMfaEnableAsync(
  token: string
): Promise<ResponseMessage<MfaSetupReponse>> {
  const response = await axios.post(
    `${API_BASE_URL}/accounts/enable-mfa`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return ResponseMessage.fromJson(response.data);
}

export async function confirmMfaAsync(
  token: string,
  mfaCode: string
): Promise<ResponseMessage<boolean>> {
  const response = await axios.post(
    `${API_BASE_URL}/accounts/confirm-mfa`,
    {
      mfaCode,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return ResponseMessage.fromJson(response.data);
}

export async function verifyMfaAsync(
  token: string,
  mfaCode: string,
  userId: string
): Promise<ResponseMessage<LoginResponse>> {
  const response = await axios.post(
    `${API_BASE_URL}/accounts/verify-mfa/${userId}`,
    {
      mfaCode,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return ResponseMessage.fromJson(response.data);
}

export async function logoutAsync(): Promise<ResponseMessage<boolean>> {
  const response = await axios.post(`${API_BASE_URL}/accounts/logout`, {}, {});

  return ResponseMessage.fromJson(response.data);
}

export async function changePasswordAsync(
  request: ChangePasswordRequest
): Promise<ResponseMessage<boolean>> {
  const response = await axios.post(
    `${API_BASE_URL}/accounts/change-password`,
    request
  );

  return ResponseMessage.fromJson<boolean>(response.data);
}
